import React from 'react';
import { Tab, TabProps as MuiTabProps } from '@mui/material';
import { NavbarItem } from 'features/navbar/types';
import { DotBadge } from 'components/DotBadge/DotBadge';

export type NavbarTabType = NavbarItem;

interface NavbarTabProps extends Omit<MuiTabProps, 'value'> {
  value: NavbarTabType;
  showBadge?: boolean;
}

const NavbarTab = ({ value, icon, showBadge, ...muiProps }: NavbarTabProps) => (
  <Tab
    value={value}
    icon={
      <DotBadge
        invisible={!showBadge}
        dotStyle={{
          height: '12px',
          width: '12px',
          borderRadius: '6px',
        }}
      >
        {icon}
      </DotBadge>
    }
    {...muiProps}
  />
);

export default NavbarTab;
